import * as actions from '../actions/AppActions';

function getTime(time) {
  return parseInt(time.getTime() / 1000, 10);
}

function convertTime(inDate, inTime) {
  const date = inDate.split('.');
  const time = inTime.split(':');
  return new Date(parseInt(date[2], 10),
    parseInt(date[1], 10) - 1,
    parseInt(date[0], 10),
    parseInt(time[0], 10),
    parseInt(time[1], 10),
    parseInt(time[2], 10));
}

class Result {
  constructor() {
    this.activeModulId = null;
    this.store = null;
    this.statisticData = '';
    this.statisticUrlShell = '';
    this.statisticUrlModule = '';
    this.startTime = 0;
    this.finishTime = 0;
  }

  setStore(store) {
    this.store = store;
  }

  setUrl(url) {
    this.statisticUrl = url;
  }

  setData(data) {
    this.statisticData = data;
  }

  setFinishTime() {
    this.finishTime = new Date();
  }

  createFormData(courseId, id, startTime, finishTime, totalTasks, totalScores, questionTotal, action) {
    const resultPercent = totalTasks === 0 ? 0 : ((totalScores / totalTasks) * 100).toFixed(0);
    const formData = new FormData();
    formData.append('id', id);
    formData.append('start_time', getTime(startTime));
    formData.append('finish_time', getTime(finishTime));
    formData.append('total_tasks', totalTasks === 0 ? totalScores : totalTasks);
    formData.append('score_percent', resultPercent);
    formData.append('correct_answer', totalScores);
    formData.append('question_total', questionTotal);
    formData.append('course_id', courseId);
    formData.append('action', action);
    formData.append('user_data', this.statisticData);
    return formData;
  }

  openModule(moduleId, courseId, onSuccess, onError) {
    this.startTime = new Date();
  }

  leaveModule(moduleId, courseId, onSuccess, onError) {
    this.setFinishTime();
    this.sendFetch(
      this.createFormData(courseId, moduleId, this.startTime, this.finishTime, 0, 0, 0, 'close'),
      onSuccess,
      onError,
    );
  }

  forceLeaveModule(moduleId, courseId) {
    navigator.sendBeacon(this.statisticUrlShell, this.createFormData(courseId, moduleId, this.startTime, this.finishTime, 0, 0, 0, 'close'));
  }

  send(data, onSuccess, onError) {
    const state = this.store.getState();
    const { courseId } = state.main.commonSettings;
    const { content } = state.main.selected;

    if (state.main.commonSettings.completeIcon === 'true') {
      this.store.dispatch(actions.finishModule(state.main.contents, state.main.selected.content));
    }

    this.setFinishTime();
    const obj = JSON.parse(data);
    this.sendFetch(this.createFormData(
      courseId,
      content,
      convertTime(obj.date, obj.startTime),
      this.finishTime,
      obj.totalTasks,
      obj.totalScores,
      obj.questionTotal,
      'finish',
    ),
    onSuccess,
    onError);
  }

  sendFetch(formData, onSuccess, onError) {
    fetch(this.statisticUrlShell, {
      method: 'POST',
      body: formData,
    }).then((response) => response.json())
      .then((response) => {
        if (onSuccess != null && typeof onSuccess === 'function') onSuccess(response);
      }).catch((error) => {
        if (onError != null && typeof onError === 'function') onError(error);
      });
  }
}

window.result = new Result();
